/* import __COLOCATED_TEMPLATE__ from './failed-bank-link.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();